export const MY_CARE_TEAM = 'My Care Team';
export const NO_CARE_TEAM = 'No Care Team';
export const NO_CARE_TEAM_FOUND = 'No Care Team found';
export const SAVE_TO_CARE_TEAM = 'Save to My Care Team';
export const REMOVE_FROM_CARE_TEAM = 'Remove from My Care Team';
export const CARE_TEAM_UPDATED = 'Successfully updated care team';
export const CARE_TEAM_UPDATE_FAIL = 'Unable to update care team';
export const YOUR_PCP_AND_CARE_TEAM = 'Your PCP and your care team';
